import { ResourceTypeBase } from './base/resource-type-base';

export class ResourceType extends ResourceTypeBase { }